import React from 'react';
import { QueueRegistry } from './queue-registry';
import { QueueRegistryContext } from './queue-registry-context';

export function QueueRegistryProvider(props: {
    children: React.ReactElement;
    queueRegistry?: QueueRegistry;
}): React.ReactElement {
    const queueRegistry: QueueRegistry = React.useState(
        () => props.queueRegistry || new QueueRegistry()
    )[0];
    return (
        <QueueRegistryContext.Provider value={queueRegistry}>
            {props.children}
        </QueueRegistryContext.Provider>
    );
}
